import api from '@/utils/api';

/**
 * 首页：公告（对应 OpenAPI api/home_notice/index）
 */
export function getHomeNotice() {
  return api.get('/home_notice/index');
}

/**
 * 首页：热榜分类 Tab（对应 OpenAPI api/leaderboard/categories）
 */
export function getLeaderboardCategories() {
  return api.get('/leaderboard/categories');
}

/**
 * 首页：某分类下的榜单条目（对应 OpenAPI api/leaderboard/items）
 * @param {Object} params
 * @param {string|number} params.category_id - 分类 ID（必填）
 */
export function getLeaderboardItems(params) {
  return api.get('/leaderboard/items', {
    params: {
      category_id: params.category_id,
    },
  });
}
